var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collegeCulture-page" },
    [
      _vm.screenType == 0
        ? _c("div", { staticClass: "cross" })
        : _c(
            "div",
            { staticClass: "vertical" },
            [
              _c(
                "van-grid",
                { attrs: { "column-num": 3, gutter: 15 } },
                _vm._l(_vm.list, function (value) {
                  return _c("van-grid-item", {
                    key: value,
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "defaultContent" },
                                [
                                  _c("van-image", {
                                    staticClass: "img",
                                    attrs: {
                                      src: require("../../../../assets/themes/img/teasLogin/bg.jpg"),
                                    },
                                    on: { click: _vm.clickImg },
                                  }),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s("校工会兴趣小组活动")),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              ),
            ],
            1
          ),
      _c("van-image-preview", {
        staticClass: "preview",
        attrs: {
          images: [_vm.showimg],
          closeable: true,
          "get-container": "#app",
        },
        model: {
          value: _vm.show,
          callback: function ($$v) {
            _vm.show = $$v
          },
          expression: "show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }